require('./ruleConditionValue.i18n.json');
require('./ruleConditionValue.tpl.html');
require('./ruleConditionValueController.js');

const RuleConditionValueComponent = {
    templateUrl: '/common/rule/ruleCondition/ruleConditionValue/ruleConditionValue.tpl.html',
    controller: 'ruleConditionValueController',
    bindings: {
        ruleConditionValue: '<',
        showLiteralValueOption: '<',
        showLeftSideFieldValueOption: '<',
        showLeftSideFieldValueClassCodeOption: '<',
        showFieldValueMultiSelectOption: '<',
        showFieldValueClassCodeMultiSelectOption: '<',
        notifyValueChanged: '&',
        canUserManageFormRules: '<',
        defaultType: '<',
        defaultFormTemplateUniqueName: '<',
        leftSideFormTemplateUniqueName: '<',
        leftSideFieldName: '<'
    }
};

angular.module('ums')
    .component('uiRuleConditionValue', RuleConditionValueComponent);
